// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607200402/js/" + chunkId + "." + {"44":"d99f6bd6","225":"99fa3255","481":"c21aeb2e","486":"708ee01e","770":"b4680745"}[chunkId] + ".0.13870957387961524.chunk.js";
};